import { Notification } from "./Notification";
import { getLeftOperatorRightFromExpression } from '../validate_expression';

const LEFT_OPERAND = 0;
const OPERATOR = 1;
const RIGHT_OPERAND = 2;

export function ConditionManager() {
  Notification.call(this);

  this.mConditions = {};
}

ConditionManager.prototype = Object.create(Notification.prototype);

ConditionManager.prototype.addCondition = function (pCondition, pInstruction, pAddFromJson) {
  const lIndex = Object.keys(this.mConditions).length;
  this.mConditions[lIndex] = pCondition;

  if(pAddFromJson) { return lIndex; }

  pInstruction.updateParams('conditions', this.toJSON());
  // TODO: maybe have a getter to last id added
  this.hasElseStatement();
  return lIndex;
};

ConditionManager.prototype.hasElseStatement = function() {
  const lHasElse = undefined != Object.values(this.mConditions).find(function (condition) { return condition.instructionType === 'else'; });
  this.notify('onConditionsChange', lHasElse);
};

ConditionManager.prototype.removeCondition = function(pIndex, pInstruction) {
  if (!this.mConditions.hasOwnProperty(pIndex)) { return; }
  delete this.mConditions[pIndex];
  pInstruction.updateParams('conditions', this.toJSON());
  this.hasElseStatement();
};

ConditionManager.prototype.setParameter = function(pParams) {
  if (pParams.name.match(/(leftOperand|operator|rightOperand)/i)) {
    const lConditionsExpressionValues = getLeftOperatorRightFromExpression(this.mConditions[pParams.id]['conditionExpression']);
    let lField = 0;

    if (pParams.name === 'leftOperand')       { lField = LEFT_OPERAND; }
    else if (pParams.name === 'operator')     { lField = OPERATOR; }
    else if (pParams.name === 'rightOperand') { lField = RIGHT_OPERAND; }
    lConditionsExpressionValues[lField] = pParams.value;

    this.mConditions[pParams.id]['conditionExpression'] = lConditionsExpressionValues.join(' ');
    pParams.instruction.notify('onParameterChanged', 'conditionExpression', this.mConditions[pParams.id]['conditionExpression'], pParams.id);
  } else {
    pParams.instruction.notify('onParameterChanged', pParams.name, pParams.value, pParams.id);
    this.mConditions[pParams.id][pParams.name] = pParams.value;
  }
  pParams.instruction.updateParams('conditions', this.toJSON());
};

ConditionManager.prototype.toJSON = function() {
  return Object.values(this.mConditions);
};
